export default __webpack_public_path__ + "static/media/instagran.bacec16f.svg";